<template>
    <div>

        <div v-if="usage.lastUpdated">
            <div class="row head">
                <div class="col col-100">Overzicht bijgewerkt tot {{ usage.lastUpdated }} </div>
            </div>
            <div class="row row-single setting">
                <div class="col col-100">
                    <div v-if="$root.app.platform == 'android'">
                    <span class="row__title">Totaal verbruik</span>
                    </div>
                    <div class="col col-50" v-if="$root.app.platform == 'ios'">
                        <span class="row__title">Totaal verbruik</span>
                    </div>
                    <div class="col col-50 text-right light" v-if="$root.app.platform == 'ios'">
                        {{ usage.totalMinutesCalled }} min
                    </div>
                </div>
                <div v-if="usage.categories" class="col col-100 usage-diagram">
                    <div v-if="$root.app.platform == 'android'" class="col col-50">
                        <ul class="usage-diagram__legenda">
                            <li class="legenda__item" v-for="(category, index) in usage.categories" v-bind:class="category.name.toLowerCase().replace(/ /g, '-').replace('085-','')">{{ category.name }}</li>
                        </ul>
                    </div>
                    <div v-if="$root.app.platform == 'android'" class="col col-50">
                        <div class="usage-diagram__donut">
                            <div v-for="(category, index) in usage.categories" class="donut__piece" :class="{'donut__piece--gt50': category.circlePiece > 180}" :style="{ transform: 'rotate(' + category.circleDistance + 'deg)'}" :data-title="category.totalMinutes+' min'">
                                <div class="donut__piece__item" v-bind:style="{ transform: 'rotate(' + category.circlePiece + 'deg)'}" :class="category.name.toLowerCase().replace(/ /g, '-').replace('085-','')"></div>
                                <div v-if="category.circlePiece > 180" class="donut__piece__item donut__piece__item--fill" :class="'cat-'+index"></div>
                            </div>
                            <div class="usage-diagram__donut__inner">{{ usage.totalMinutesCalled }} min</div>
                        </div>
                    </div>
                    <div v-if="$root.app.platform == 'ios'" class="usage-diagram__bar">
                        <div v-for="(category, index) in usage.categories" class="bar__piece" v-bind:style="{ width: category.percentage + '%'}" :class="category.name.toLowerCase().replace(/ /g, '-').replace('085-','')"></div>
                    </div>
                    <ul v-if="$root.app.platform == 'ios'" class="usage-diagram__legenda">
                        <li class="legenda__item" v-for="(category, index) in usage.categories" v-bind:class="category.name.toLowerCase().replace(/ /g, '-').replace('085-','')">{{ category.name }}</li>
                    </ul>
                </div>
            </div>
            <!--
            <div class="row row-last setting has-subitem" v-if="$root.user.isAdmin">
                <router-link to="/subscriptions">
                    <div v-if="$root.app.platform == 'android'" class="col col-100">
                        <span class="row__title">Wijzig abonnement</span><br/>

                    </div>
                    <div v-if="$root.app.platform == 'ios'" class="col col-60">
                        <span class="row__title">Wijzig abonnement</span>
                    </div>
                    <div v-if="$root.app.platform == 'ios'" class="col col-40">
                       <span class="row__subtitle">...</span>
                    </div>
                </router-link>
            </div>
            -->
            <div v-if="usage.categories">
                <div class="row spacer">&nbsp;</div>

                <div class="row head">
                    <div class="col col-100">Specificaties</div>
                </div>
                <div class="row row-list-item setting" v-for="(category, index) in usage.categories" v-bind:class="{'row-last': usage.categories.length - 1 === index}">
                    <div class="col col-100 usage" v-bind:class="category.name.toLowerCase().replace(/ /g, '-').replace('085-','')">
                        <div class="row__title">{{ category.name }}</div>
                        <div class="small">{{ category.totalCalls }} gesprekken<br/>
                            {{ category.totalMinutes }} minuten</div>
                    </div>
                </div>
            </div>

            <div class="row spacer" v-if="$root.app.platform == 'ios'">&nbsp;</div>
        </div>
        <div v-else>
            <div class="row head">
                <div class="col col-100">Verbruik</div>
            </div>
            <div class="row explanation">
                <div class="col col-100">
                    Nog geen gegevens beschikbaar. Probeer het later nog een keer.
                </div>
            </div>
        </div>
        <!-- remove testGroup after it is tested -->
        <div class="call-history" v-if="testGroup">
            <div class="current-month" v-if="callsCurrentMonth">
                <div class="row head">
                    <div class="col col-100">{{convertToMonthYear(callHistoryCurrentMonth.periodStart.substring(0,10))}} <span @click="downloadCurrentMonth" class="download"><img src="@/assets/images/send-invoice.svg"></span></div>

                </div>
                
                    <div class="row row-list-item setting" v-for="call in callsCurrentMonth" :key="call.id">
                        <div class="call-type col col-50">
                            <div v-if="call.type == 'O'">
                                <div class="col col-100">{{call.calledNumber}}</div>
                                <div class="col col-100">Uitgaand</div>
                            </div>
                            <div v-else>
                                <div class="col col-100">{{call.telephoneNumber}}</div>
                                <div class="col col-100">Inkomend</div>
                            </div>
                        </div>
                        <div class="col col-50">
                            <div class="col col-90">{{convertToDayMonth(call.date)}} {{convertToClock(call.time)}}</div>
                            <div class="col col-90">{{convertToDuration(call.duration)}}</div>
                            <div class="call-type-icon" v-if="call.type =='O'">
                                <img src="@/assets/images/outboundcall.svg">
                            </div>
                            <div class="call-type-icon" v-else>
                                <img src="@/assets/images/inboundcall.svg">
                            </div>
                        </div>
                    </div>
                
            </div>
            <div class="previous-month" v-if="callsPreviousMonth">
                 <div class="row head">
                    <div class="col col-100">{{convertToMonthYear(callHistoryPreviousMonth.periodStart.substring(0,10))}} <span @click="downloadPreviousMonth" class="download"><img src="@/assets/images/send-invoice.svg"></span></div>
                </div>
                
                    <div class="row row-list-item setting" v-for="call in callsPreviousMonth" :key="call.id">
                        <div class="call-type col col-50">
                            <div v-if="call.type == 'O'">
                                <div class="col col-100">{{call.calledNumber}}</div>
                                <div class="col col-100">Uitgaand</div>
                            </div>
                            <div v-else>
                                <div class="col col-100">{{call.telephoneNumber}}</div>
                                <div class="col col-100">Inkomend</div>
                            </div>
                        </div>
                        <div class="col col-50">
                            <div class="col col-90">{{convertToDayMonth(call.date)}} {{convertToClock(call.time)}}</div>
                            <div class="col col-90">{{convertToDuration(call.duration)}}</div>
                            <div class="call-type-icon" v-if="call.type =='O'">
                                <img src="@/assets/images/outboundcall.svg">
                            </div>
                            <div class="call-type-icon" v-else>
                                <img src="@/assets/images/inboundcall.svg">
                            </div>
                        </div>
                    </div>
                    
                
                
            </div>
            <div class="row spacer">&nbsp;</div>
        </div>
    </div>

</template>

<script>
import moment from 'moment'
moment.locale('nl');
    export default {
    name: 'Usage',
        data () {

            return {
                usage: [],
                callHistoryPreviousMonth: [],
                callHistoryCurrentMonth: [],
                callsCurrentMonth: [],
                callsPreviousMonth: [],
                testGroup: false,
            }
        },

        methods:{
            getCurrentMonthCallHistory() {
                this.$api.get('/usage/currentandpreviousmonth/' + this.$root.user.poc)
                .then(response => {

                    this.callsCurrentMonth = response.data.data.currentMonth.calls.reverse();
                    this.callsPreviousMonth = response.data.data.previousMonth.calls.reverse();

                    this.callHistoryCurrentMonth = response.data.data.currentMonth;
                    this.callHistoryPreviousMonth = response.data.data.previousMonth;

                    this.testGroup = true;
                })
                .catch(e => {


                })
            },
            downloadCurrentMonth() {
              var startPeriod = this.callHistoryCurrentMonth.periodStart.substring(0,10);
              var month = this.convertToMonth(startPeriod);
              var year = this.convertToYear(startPeriod);
              var _this = this;
                this.$api.get('/usage/downloadcurrentmonth/' + this.$root.user.poc + '/' + month + '/' + year)
                .then(response => {
                  _this.$root.ui.showDialog(
                    'Verstuurd',
                    'De belgegevens van deze maand zijn verstuurd naar je emailadres.',
                    true
                  );
                })
                .catch(e => {
                    console.log(e)

                })
            },

            downloadPreviousMonth() {
              var startPeriod = this.callHistoryPreviousMonth.periodStart.substring(0,10);
              var month = this.convertToMonth(startPeriod);
              var year = this.convertToYear(startPeriod);
              var _this = this;

                this.$api.get('/usage/downloadpreviousmonth/' + this.$root.user.poc + '/' + month + '/' + year)
                .then(response => {
                  _this.$root.ui.showDialog(
                    'Verstuurd',
                    'De belgegevens van vorige maand zijn verstuurd naar je emailadres.',
                    true
                  );
                    //this.downloadAsCSV(response.data, this.convertToMonthYear(this.callHistoryPreviousMonth.date.substring(0,10)) + '.csv')
                })
                .catch(e => {
                    console.log(e)

                })
            },

            downloadAsCSV(longCSVString, fileName) {

                const csvBlob = new Blob([longCSVString], {
                    type: 'text/plain;charset=UTF-8;'
                });

                //for IE11 & Edge
                if (navigator.msSaveBlob) {
                    navigator.msSaveBlob(csvBlob, fileName);
                } else {
                    //for modern browsers
                    const link = document.createElement('a');
                    const url = window.URL.createObjectURL(csvBlob);
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setTimeout(() => {
                    window.URL.revokeObjectURL(url);
                    });
                }
            },

            convertToMonthYear(date) {
                return moment(date, 'DD-MM-YYYY').format('MMMM YYYY')
            },

            convertToMonth(date) {
              return moment(date, 'DD-MM-YYYY').format('MMMM')
            },

            convertToYear(date) {
              return moment(date, 'DD-MM-YYYY').format('YYYY')
            },

            convertToDayMonth(date) {
                return moment(date, 'DD-MM-YYYY').format('D MMMM')
            },

            convertToClock(time) {
                return moment(time, 'HH:mm:ss').format('H:mm')
            },

            convertToDuration(time) {

                if(moment(time, 'HH:mm:ss').format('H') == 0 && moment(time, 'HH:mm:ss').format('m') != 0) {
                    return moment(time, 'HH:mm:ss').format('m [min] s [sec]')
                }

                if(moment(time, 'HH:mm:ss').format('m') == 0) {
                    return moment(time, 'HH:mm:ss').format('s [sec]')
                }

                return moment(time, 'HH:mm:ss').format('H uur m [min] s [sec]')
            },
        },

        mounted(){
            this.getCurrentMonthCallHistory();

            this.$api.get('/usage')
            .then(response => {

                this.usage = response.data;
            })
            .catch(e => {

            })
        },

    }
</script>



// WEBPACK FOOTER //
// src/components/Usage.vue